import { render, staticRenderFns } from "./DragAppointment.vue?vue&type=template&id=223ecc00&scoped=true&"
import script from "./DragAppointment.vue?vue&type=script&lang=ts&"
export * from "./DragAppointment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223ecc00",
  null
  
)

export default component.exports